import React, { useEffect } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { useTranslation } from 'react-i18next';
import Select from 'components/@common/Inputs/Select';
import { useField } from 'formik';
import { DATE_RANGE_OPTIONS } from '../../../utils/report-param-utils';

type Props = {
  name?: string;
} & React.ComponentProps<typeof Select>;

const DateRangeField: React.FC<Props> = ({ name = 'dateRange', ...props }) => {
  const { t } = useTranslation('Reports');
  const [field, meta, { setValue }] = useField(name);
  const dateRange = field.value;

  useEffect(() => {
    if (!DATE_RANGE_OPTIONS.some(option => option.value === dateRange)) {
      setValue(null);
    }
  }, [dateRange, setValue]);

  return (
    <Select
      label={t('Select Date Range')}
      placeholder={t('Select Date Range')}
      size="small"
      inputProps={{
        'aria-label': t('Select Date Range')
      }}
      {...field}
      {...props}
      error={!!meta.error && meta.touched}
    >
      {DATE_RANGE_OPTIONS.map(option => (
        <MenuItem key={`${option.value}-option-date`} value={option.value}>
          {option.name}
        </MenuItem>
      ))}
    </Select>
  );
};

export default DateRangeField;
